import { TrackedCard, TrackedCardJob } from '../../../redux/api/kit-staging';

/** A paired view of one OLI's kit and material TrackedCards. */
export interface OliGroup {
	oli: string;
	job: TrackedCardJob | null;
	kitCard: TrackedCard | null;
	materialCard: TrackedCard | null;
}

/** Group flat TrackedCards by order_line_item_id into kit/material pairs.
 *  Groups are returned in ascending OLI order. */
export function groupByOli(cards: TrackedCard[]): OliGroup[] {
	const byOli = new Map<string, OliGroup>();
	for (const c of cards) {
		let g = byOli.get(c.order_line_item_id);
		if (!g) {
			g = { oli: c.order_line_item_id, job: null, kitCard: null, materialCard: null };
			byOli.set(c.order_line_item_id, g);
		}
		if (c.item_type === 'kit') g.kitCard = c;
		else if (c.item_type === 'material') g.materialCard = c;
		if (!g.job && c.job) g.job = c.job;
	}
	return Array.from(byOli.values()).sort((a, b) => a.oli.localeCompare(b.oli));
}
